module.exports = __webpack_public_path__ + "static/img/homeSnap.ec4f6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeSnap.png
// module id = 686
// module chunks = 107